'use strict';

var RomSummaryPOSChartFilterFactory = function RomSummaryPOSChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMOptGroupWeekFilterFactory', 'ROMSummaryCabinFilterFactory', 'ROMSummaryDOWFilterFactory', 'ROMSummaryRomTimeBucketFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function RomSummaryPOSChartFilter() {
    DemandFilter.call(this, 'rom-summary-mode', 'point-of-sale-thematic-chart');
    this.registerFilters(injectedFilters);
  }
  RomSummaryPOSChartFilter.constructor = RomSummaryPOSChartFilter;
  RomSummaryPOSChartFilter.prototype = Object.create(DemandFilter.prototype);
  return RomSummaryPOSChartFilter;
};
RomSummaryPOSChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = RomSummaryPOSChartFilterFactory;